<template>
  <Flex center tabindex="-1" class="min-h-screen overflow-hidden fixed z-50 w-screen h-screen inset-0 bg-cockpit-canvas/85 transition-opacity" v-if="inputValue">
    <Card variant="cockpit" rounded class="relative p-3 max-h-[85vh] shadow-lg" :class="size">
      <FlexCol gap-2 class="h-full">
        <Flex justify-end v-if="!disableClose">
          <IconSolid icon="fa-xmark" class="cursor-pointer text-cockpit-muted hover:text-cockpit-green" @click="update" />
        </Flex>

        <Flex justify-between items-scenter class="pb-2 mb-3 border-b border-cockpit-line" v-if="header && title">
          <div>
            <IconSolid v-if="icon" :icon="icon" class="mr-2 text-lg" :class="iconClassComputed" />
            <b>{{ title }}</b>
          </div>
        </Flex>
        <div class="grow" :class="overflowVisible ? 'overflow-visible' : 'overflow-y-auto'">
          <slot></slot>
        </div>
        <Flex gap-3 justify-end>
          <slot name="footer" class="pt-3"> </slot>
        </Flex>
      </FlexCol>
    </Card>
  </Flex>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
//  Props
const props = defineProps({
  icon: String,
  iconClass: String,
  header: { type: Boolean, default: true },
  modelValue: Boolean,
  size: {
    type: String,
    default: 'w-10/12',
  },
  title: String,
  disableClose: Boolean,
  overflowVisible: Boolean,
})
//  Emits
const emit = defineEmits(['update:modelValue'])
// Datas
const inputValue = ref(props.modelValue)
// Computeds
const iconClassComputed = computed(() => {
  return [props.iconClass]
})
// Métodos
const update = () => {
  inputValue.value = !inputValue.value
  emit('update:modelValue', inputValue.value)
}
//  Watchers
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== inputValue.value) {
      inputValue.value = newValue
    }
  },
)
</script>
